import { getPaymentTokenizer } from "@/api/IPaymentTokenizeApi";
import { createApiException } from "@/api/ResponseModel";
import PaymentSource from "@/models/APIModels/PaymentSource";
import BankDetails from "@/models/BankDetails";
import { CardDetails, CardDetailsViewModel } from "@/models/CardDetails";
import { formatBankAccount } from "@/shared/helperFunctions";

export default class PaymentTokenizeUseCase {
  async tokenizeCard(
    cardDetailsViewModel: CardDetailsViewModel,
    userCategory = "UC_D"
  ) {
    try {
      let { cardNumber, ...card } = cardDetailsViewModel;

      let cardDetails = {
        ...card,
        cardNumber: Number(cardNumber.replaceAll(" ", "")),
      };
      const paymentTokenizeApi = getPaymentTokenizer(userCategory);
      return await paymentTokenizeApi.tokenizeCard(cardDetails, userCategory);
    } catch (error) {
      throw error;
    }
  }
  async tokenizeBankDetails(bankDetails: BankDetails, userCategory = "UC_D") {
    try {
      const paymentTokenizeApi = getPaymentTokenizer(userCategory);
      return {
        ...(await paymentTokenizeApi.tokenizeBankDetails(bankDetails)),
        number: formatBankAccount(bankDetails.bankAccountNumber).replace(
          " ",
          ""
        ),
      };
    } catch (error) {
      throw error;
    }
  }

  async tokenize(paymentSource: PaymentSource, userCategory = "UC_D") {
    try {
      const paymentTokenizeApi = getPaymentTokenizer(userCategory);
      switch (paymentSource.paymentSourceTypeCd) {
        case "PST_CC":
          const card: CardDetails = {
            cardholderName: paymentSource.name,
            cardNumber: Number(paymentSource.numberMask!.replaceAll(" ", "")),
            expiryYear: Number(paymentSource.expiryYear),
            expiryMonth: Number(paymentSource.expiryMonth),
            ccv: paymentSource.ccv!,
          };

          return await paymentTokenizeApi.tokenizeCard(card, userCategory);

        case "PST_BA":
          const bsb = paymentSource.bsb!.replace("-", "");
          const bank: BankDetails = {
            bankAccountName: paymentSource.name,
            bankAccountBSB: bsb,
            bankAccountNumber: paymentSource.number!,
          };
          const result = await paymentTokenizeApi.tokenizeBankDetails(bank);
          return {
            ...result,
            bsb: `${result.bsb?.substring(0, 3)}-${result.bsb?.substring(3)}`,
            number: formatBankAccount(result.number).replace(" ", ""),
          };

        default:
          throw createApiException("Unsupported Payment Type");
      }
    } catch (error) {
      throw error;
    }
  }
}
